import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useLoggedOutStorage from '@/hooks/use-logged-out-storage';
type LoginQuery = {
  orgId?: string;
  redirectUrl?: string;
};

/**
 * Sometimes we are sent to the login page with arguments that specify what to do after login is complete,
 * like redirecting to the last visited page.
 * Since the login flow requires redirecting and we'll lose the querystring, let's capture the querystring
 * arguments and save them into local storage for when login is complete.
 * */
const useCaptureQueryParams = () => {
  const $ = _c(5);
  const {
    query,
    isReady
  } = useRouter();
  const loginQuery = query as LoginQuery;
  const {
    update
  } = useLoggedOutStorage();
  let t0;
  let t1;
  if ($[0] !== isReady || $[1] !== loginQuery || $[2] !== update) {
    t0 = () => {
      if (!isReady) {
        return;
      }
      update({
        orgId: loginQuery.orgId,
        redirectUrl: loginQuery.redirectUrl
      });
    };
    t1 = [isReady, loginQuery, update];
    $[0] = isReady;
    $[1] = loginQuery;
    $[2] = update;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};
export default useCaptureQueryParams;